<template>
  <div>
    <h1 class="title_welcome">{{ $t('welcome_popup.tournament.tournament_title') }}</h1>
    <p class="from_to_data_welcome" style="text-align: center">
      {{ getTournamentStartData }} — {{ getTournamentFinishData }}
    </p>
    <h2 class="price_fond_welcome">{{ $t('welcome_popup.tournament.prize_fund') }} {{ getTournamentTotalPrize }}</h2>
    <ul class="info_list_welcome">
      <li class="info_item_welcome">
        {{ $t('welcome_popup.tournament.text_1', { gameNameList: getTournamentGameNamesList }) }}
      </li>
      <li class="info_item_welcome">
        <template v-if="isProviderPatriana">
          {{ patrianaRule }}
        </template>

        <template v-else>
          {{
            $t('welcome_popup.tournament.text_2', {
              minBet: getTournamentMinBet,
              currencyCode: getFormatedCurrency
            })
          }}
        </template>

        {{ $t('welcome_popup.tournament.text_3') }}
      </li>
      <li class="info_item_welcome" v-if="getTournamentMinRounds">
        {{ $t('welcome_popup.tournament.text_4', { minSpins: getTournamentMinRounds }) }}
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Vue from 'vue';
import { Utils } from '@/utils/Utils';

export default Vue.extend({
  name: 'TournamentWelcomeContent',
  computed: {
    ...mapGetters([
      'getTournamentStartData',
      'getTournamentGameNamesList',
      'getTournamentMinBet',
      'getTournamentCurrency',
      'getTournamentFinishData',
      'getTournamentTotalPrize',
      'getTournamentMinRounds'
    ]),
    getFormatedCurrency() {
      return Utils.formatCurrencyCodeToMili(this.getTournamentCurrency);
    },
    currentProvider() {
      return Utils.parseGetParams('provider') || '';
    },
    isProviderPatriana() {
      return this.currentProvider === 'patriana';
    },
    patrianaRule(){
      return `To participate in the tournament, the player must go to the Gamzix games and choose a play amount only with coin type from ${this.getTournamentMinBet} ${this.getFormatedCurrency} and above.`
    }
  }
});
</script>

<style scoped>
.info_list_welcome {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
